import React from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';

import CustomReactSelect from '@components/CustomReactSelect';
import CustomDropdown from '@components/CustomDropdown';

export const renderDropdown = (label, items = [], selectedItem = '', onItemClick, error = '') => (
	<div className="col-md-6">
		<div className="form-group">
			<label>{label}</label>
			<CustomDropdown
				type="addItem"
				isAddNew={false}
				onItemClick={onItemClick}
				items={items}
				selectedItem={selectedItem}
			/>
			{error && <p className="error d-block">{error}</p>}
		</div>
	</div>
);

export const renderAsyncDropdown = (
	label,
	promiseOptions,
	onSetSelectedItem,
	selectedValue,
	title = 'Select',
	isMulti = false,
	defaultOptions = true,
	error = '',
	className = 'col-md-6'
) => {
	return (
		<div className={className}>
			<div className="form-group no-shadow-react-select size36">
				<CustomReactSelect
					isMulti={isMulti}
					label={label}
					type="ASYNC"
					loadOptions={promiseOptions}
					onSetSelectedItem={onSetSelectedItem}
					selectedValue={selectedValue}
					title={title}
					defaultOptions={defaultOptions}
				/>
				{error && <p className="error d-block">{error}</p>}
			</div>
		</div>
	);
};

export const renderCreatableDropdown = (
	promiseOptions,
	onCreateOption,
	onItemClick,
	className = 'col-md-6'
) => {
	return (
		<div className={className}>
			<div className="form-group no-shadow-react-select size36">
				<AsyncCreatableSelect
					placeholder="Search with reference number"
					cacheOptions
					defaultOptions
					loadOptions={promiseOptions}
					onCreateOption={onCreateOption}
					onChange={onItemClick}
					isValidNewOption={(inputValue, _selectValue, selectOptions) => {
						const matchingOptions = selectOptions.filter((option) =>
							option.referenceNumber.toLowerCase().includes(inputValue.toLowerCase())
						);
						const isTyping = inputValue.trim().length > 0;
						return matchingOptions.length === 0 && isTyping;
					}}
				/>
			</div>
		</div>
	);
};
